const TickerTapeSymbols = [
  {
    proName: 'BSE:ADANIPORTS',
    title: 'ADANIPORTS',
  },
  {
    proName: 'BSE:ASIANPAINT',
    title: 'ASIANPAINT',
  },
  {
    proName: 'BSE:BHARTIARTL',
    title: 'BHARTIARTL',
  },
  {
    proName: 'BSE:CIPLA',
    title: 'CIPLA',
  },
  {
    proName: 'BSE:COALINDIA',
    title: 'COALINDIA',
  },
  {
    proName: 'BSE:DIVISLAB',
    title: 'DIVISLAB',
  },
  {
    proName: 'BSE:DRREDDY',
    title: 'DRREDDY',
  },
  {
    proName: 'BSE:EICHERMOT',
    title: 'EICHERMOT',
  },
  {
    proName: 'BSE:GRASIM',
    title: 'GRASIM',
  },
  {
    proName: 'BSE:HCLTECH',
    title: 'HCLTECH',
  },
  {
    proName: 'BSE:HEROMOTOCO',
    title: 'HEROMOTOCO',
  },
  {
    proName: 'BSE:HINDALCO',
    title: 'HINDALCO',
  },
  {
    proName: 'BSE:HINDUNILVR',
    title: 'HINDUNILVR',
  },
  {
    proName: 'BSE:ICICIBANK',
    title: 'ICICIBANK',
  },
  {
    proName: 'BSE:ITC',
    title: 'ITC',
  },
  {
    proName: 'BSE:INDUSINDBK',
    title: 'INDUSINDBK',
  },
  {
    proName: 'BSE:INFY',
    title: 'INFY',
  },
  {
    proName: 'BSE:JSWSTEEL',
    title: 'JSWSTEEL',
  },
  {
    proName: 'BSE:BPCL',
    title: 'BPCL',
  },
  {
    proName: 'BSE:BAJAJ_AUTO',
    title: 'BAJAJ_AUTO',
  },

  {
    proName: 'BSE:AXISBANK',
    title: 'AXIS',
  },
  {
    proName: 'BSE:BAJFINANCE',
    title: 'BAJFINANCE',
  },
  {
    proName: 'BSE:RELIANCE',
    title: 'RELIANCE',
  },
  {
    proName: 'BSE:APOLLOHOSP',
    title: 'APOLLOHOSP',
  },

  {
    proName: 'BSE:KOTAKBANK',
    title: 'KOTAKBANK',
  },

  {
    proName: 'BSE:LT',
    title: 'LT',
  },

  {
    proName: 'BSE:M_M',
    title: 'M&M',
  },

  {
    proName: 'BSE:MARUTI',
    title: 'MARUTI',
  },

  {
    proName: 'BSE:NTPC',
    title: 'NTPC',
  },

  {
    proName: 'BSE:NESTLEIND',
    title: 'NESTLEIND',
  },

  {
    proName: 'BSE:ONGC',
    title: 'ONGC',
  },

  {
    proName: 'BSE:POWERGRID',
    title: 'POWERGRID',
  },

  {
    proName: 'BSE:SBILIFE',
    title: 'SBILIFE',
  },

  {
    proName: 'BSE:SHREECEM',
    title: 'SHREECEM',
  },

  {
    proName: 'BSE:SBIN',
    title: 'SBIN',
  },

  {
    proName: 'BSE:SUNPHARMA',
    title: 'SUNPHARMA',
  },

  {
    proName: 'BSE:TCS',
    title: 'TCS',
  },

  {
    proName: 'BSE:TATACONSUM',
    title: 'TATACONSUM',
  },

  {
    proName: 'BSE:TATAMOTORS',
    title: 'TATAMOTORS',
  },

  {
    proName: 'BSE:TATASTEELPP',
    title: 'TATASTEEL',
  },

  {
    proName: 'BSE:TECHM',
    title: 'TECHM',
  },

  {
    proName: 'BSE:TITAN',
    title: 'TITAN',
  },

  {
    proName: 'BSE:UPL',
    title: 'UPL',
  },

  {
    proName: 'BSE:ULTRACEMCO',
    title: 'ULTRACEMCO',
  },

  {
    proName: 'BSE:WIPRO',
    title: 'WIPRO',
  },
];

export default TickerTapeSymbols;
